import { KeycloakProfile } from 'keycloak-js'

/** Local representation of a Keycloak user, mirroring the fields available from the Keycloak Admin REST API. */
export class KeycloakUser {
  public id: string;
  public username: string;
  public firstName: string;
  public lastName: string;
  public email: string;
  public enabled: boolean;
  public emailVerified: boolean;
  public createdTimestamp: number;

  constructor(id: string, username: string, firstName: string, lastName: string, email: string, enabled: boolean, emailVerified: boolean, createdTimestamp: number) {
    this.id = id;
    this.username = username;
    this.firstName = firstName;
    this.lastName = lastName;
    this.email = email;
    this.enabled = enabled;
    this.emailVerified = emailVerified;
    this.createdTimestamp = createdTimestamp;
  }

  /** Creates a `KeycloakUser` from the minimal `KeycloakProfile` returned by `KeycloakService.loadUserProfile()`. */
  public static fromProfile(profile: KeycloakProfile): KeycloakUser {
    return new KeycloakUser(
      profile.id,
      profile.username,
      profile.firstName,
      profile.lastName,
      profile.email,
      true, // Assuming enabled is true for the user
      false, // Assuming emailVerified is false for the user
      Date.now() // Assuming createdTimestamp is current time
    );
  }
}
